import { render, staticRenderFns } from "./UserDataForm.vue?vue&type=template&id=4bafaa4f&scoped=true"
import script from "./UserDataForm.vue?vue&type=script&lang=js"
export * from "./UserDataForm.vue?vue&type=script&lang=js"
import style0 from "./UserDataForm.vue?vue&type=style&index=0&id=4bafaa4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bafaa4f",
  null
  
)

export default component.exports